define('modules/stats/views/main',['require','exports','module','base/view','i18n','./listing','ldsh!../templates/main'],function (require, exports, module) {
  'use strict';

  var BaseView = require('base/view'),
    i18n = require('i18n'),
    CollectionView = require('./listing');

  module.exports = BaseView.extend({
    template: require('ldsh!../templates/main'),
    className: 'ed-leads',
    events: {},

    initialize: function (options) {
      this.date = options.date;
      this.collection = options.collection;
      this.listenTo(this.date, 'setValues', this.changeDate);
      this.listenTo(this.collection, 'sync', this.render);
    },
    helpers: function () {},
    changeDate: function () {
      this.$('.js-spinner').show();
      this.collection.fetch({
        reset: true,
        data: _.clone(this.date.attributes),
      });
    },
    onRender: function () {
      this.$el.i18n();
      this.$('.js-spinner').hide();
      if (this.collection.loaded) {
        var tableView = new CollectionView({ collection: this.collection });
        this.$('.ed-table-container').html(tableView.render().$el);
      }
    },
  });
});

